export const PAYMENT_DETAIL = '/Checkout/CheckOutThankyou';

export const DOWNLOAD_INVOICE = '/OrderReport/DownloadOrder';
